<!--  -->
<template>
  <div v-loading="loadingtable">
    <div class="werw" style="margin-bottom:10px">
      <div v-if="fullName" class="select_box" :class="[fullName?'test_check':'']" @click="whole" />
      <div v-else class="select_box" :class="[fullName?'test_check':'']" @click="wholer" />
      <div v-if="fullName" @click="whole">
        取消全选
      </div>
      <div v-else @click="wholer">
        全选
      </div>
    </div>
    <div class="choose_box">
      <div v-for="item,index in data" :key="index" style="margin-bottom:10px;margin-right:10px">
        <div class="werw">
          <div v-if="item.groups.length!==0 && item.can_checked !== 9" class="select_box" :class="{test_check:item.check === true}" @click="itemall(item)" />
          <div v-else class="noselect_box" />
          {{ item.name }}
        </div>
        <div v-for="itemsr,indexr in item.groups" :key="indexr" style="margin-left:10px;margin-top:10px" @click="zi(itemsr,item)">
          <div class="werw">
            <div v-if="itemsr.can_checked !== 9" class="select_box" :class="{test_check:itemsr.check === true}" />
            <div v-else class="noselect_box" />
            <div class="werw">
              <div>{{ itemsr.group_chat_name }}</div>
              <div class="group_box">（{{ itemsr.group_chat_id }}）</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[50]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-button type="primary" @click="sumbit">确定</el-button>
    </div>
  </div>
</template>

<script>
import { spgrounp } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      data: [],
      query: {
        page: 1,
        pageSize: 50,
        sp_strategy_no: null
      },
      total: null,
      carlist: [],
      check: true,
      arrsw: [],
      sp_strategy_no: null,
      loadingtable: false
    }
  },
  computed: {
    fullName: function() {
      return this.data.filter((num) => {
        return num.groups.length !== 0 && num.can_checked !== 9
      }).every(function(item) {
        return item.check === true
      })
    }
  },

  created() {

  },
  mounted() {

  },
  methods: {
    send(id) {
      this.sp_strategy_no = id
      this.query.sp_strategy_no = id
      this.list()
    },
    async list() {
      this.loadingtable = true
      const data = await spgrounp(this.query)
      this.total = data.data.total
      data.data.list.forEach(element => {
        element.check = false
        element.groups.forEach(item => {
          item.check = false
        })
      })

      console.log('carlist', this.carlist)
      this.data = data.data.list
      // this.carlist.forEach(items => {

      // })
      this.data.forEach(ir => {
        ir.groups.forEach(item => {
          this.carlist.forEach(items => {
            if (item.group_chat_id === items.group_chat_id) {
              item.check = true
              this.all()
            }
          })
        })
      })
      this.loadingtable = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    itemall(item) {
      if (item.check === false) {
        item.check = true
        item.groups.forEach((element) => {
          if (element.can_checked !== 9) {
            element.check = true
            const index = this.carlist.findIndex((items) => {
              return items.group_chat_id === element.group_chat_id
            })
            if (index === -1) {
              this.carlist.push(element)
            }
          }
        })
      } else {
        console.log('666')
        item.check = false
        item.groups.forEach((item) => {
          item.check = false
          const index = this.carlist.findIndex((items) => {
            return items.group_chat_id === item.group_chat_id
          })
          this.carlist.splice(index, 1)
        })
      }
      console.log('this.carlistallllll', this.carlist)
    },
    zi(item, we) {
      if (item.can_checked !== 9) {
        item.check = !item.check
        const flag = we.groups.every(function(a, b, c) {
          return a.check === true || a.can_checked === 9// 数组中的每个元素的值都要大于2000的情况,最后才返回true
        })
        if (flag) {
          we.check = true
          console.log('111')
        } else {
          we.check = false
        }
        if (item.check) {
          this.carlist.push(item)
        } else {
          const index = this.carlist.findIndex((items) => {
            return items.group_chat_id === item.group_chat_id
          })
          this.carlist.splice(index, 1)
        }
        console.log('this.carlist', this.carlist)
      }
    },
    all() {
      this.data.forEach(element => {
        const flag = element.groups.every(function(a, b, c) {
          return a.check === true// 数组中的每个元素的值都要大于2000的情况,最后才返回true
        })
        if (flag) {
          element.check = true
        } else {
          element.check = false
        }
      })
    },
    sumbit() {
      console.log('arrs', this.arrs)
      this.arrsw = []
      this.arrsw = this.carlist.map(item => { // item是数组中的每一个值
        return {
          group_chat_id: item.group_chat_id,
          group_chat_owner: item.group_chat_owner,
          employee_no: item.employee_no
        }
      })
      if (this.carlist.length === 0) {
        this.$message.error('请选择要绑定的群组')
        return
      }
      this.$emit('bandarr', this.arrsw, this.sp_strategy_no, 2)
    },
    whole() {
      this.carlist = []
      this.data.forEach(item => {
        if (item.can_checked !== 9) {
          if (item.groups.length !== 0) {
            item.check = false
            item.groups.forEach(element => {
              if (element.can_checked !== 9) {
                element.check = false
              }
            })
          }
        }
      })
    },
    wholer() {
      this.carlist = []
      this.data.forEach(item => {
        if (item.can_checked !== 9) {
          if (item.groups.length !== 0) {
            item.check = true
            item.groups.forEach(element => {
              if (element.can_checked !== 9) {
                element.check = true
                this.carlist.push(element)
              }
            })
          }
        }
      })
      console.log(this.carlist)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.noselect_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
  background: #ccc;
}
.test_check{
  background: #409eff;
}
.werw{
  display: flex;
  align-items: center;
}
.group_box{
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.choose_box{
    display: flex;
    height: 400px;
    flex-wrap: wrap;
    flex-direction: column;
    max-width: 890px;
    overflow-x: auto;
}
</style>
